// src/components/Header.js
import React from 'react';
import {
  Box, Flex, HStack, Link, IconButton, Button, Text,
  useColorModeValue, Spacer, Image, useDisclosure, Collapse, VStack,
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { FaFacebookF, FaTwitter, FaInstagram } from 'react-icons/fa';
import { Link as RouterLink } from 'react-router-dom';
import LogoPNG from '../assets/logo_.png';
import SmartNavLink from '../components/SmartNavLink'; 

const Logo = () => (
  <RouterLink to="/">
    <Image src={LogoPNG} alt="Anbelat Logo" boxSize="40px" objectFit="contain" />
  </RouterLink>
);

export default function Header() {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const { isOpen, onToggle, onClose } = useDisclosure();

  // Your original navLinks array - now it works perfectly!
  const navLinks = [
    { name: 'Services', to: 'services', type: 'scroll' },
    { name: 'Projects', to: 'projects', type: 'scroll' },
    { name: 'About Us', to: 'about', type: 'scroll' },
    { name: 'Gallery', to: '/gallery', type: 'link' },
    { name: 'Contact Us', to: 'contact', type: 'scroll' },
  ];

  return (
    <Box position="sticky" top="0" zIndex="sticky" bg="white">
      {/* Top Bar */}
      <Box bg={bgColor} px={4} borderBottomWidth="1px" borderColor="gray.200">
        <Flex h={10} alignItems="center" justifyContent="space-between" maxW="7xl" mx="auto">
          <HStack spacing={4} fontSize="sm">
            <Text>📞 +251911499494</Text>
            <Text>✉️ info@anbelat.com</Text>
          </HStack>
          <Spacer />
          <HStack spacing={3}>
            <IconButton as={Link} href="https://www.instagram.com/anbelat_construction/" variant="ghost" size="sm" icon={<FaInstagram />} aria-label="Instagram" />
            <IconButton as={Link} href="https://x.com/AnbelatC40568" variant="ghost" size="sm" icon={<FaTwitter />} aria-label="Twitter" />
            <IconButton as={Link} href="#" variant="ghost" size="sm" icon={<FaFacebookF />} aria-label="Facebook" />
          </HStack>
        </Flex>
      </Box>

      {/* Main Navigation */}
      <Box px={4} shadow="md">
        <Flex h={16} alignItems="center" justifyContent="space-between" maxW="7xl" mx="auto">
          <Logo />

          {/* Desktop Navigation */}
          <HStack as="nav" spacing={8} display={{ base: 'none', md: 'flex' }} ml={10}>
            <RouterLink to="/" style={{ cursor: 'pointer', fontWeight: 'bold', color: 'orange' }}>Home</RouterLink>
            {navLinks.map((link) => (
              <SmartNavLink key={link.name} to={link.to} type={link.type}>
                {link.name}
              </SmartNavLink>
            ))}
          </HStack>
          <Spacer display={{ base: 'none', md: 'block' }} />

          <Flex alignItems="center">
            <Button as={RouterLink} to="/contact" colorScheme="orange" variant="solid" size="md" display={{ base: 'none', md: 'inline-flex' }}>
              Get A Quote
            </Button>
            <IconButton size="md" icon={isOpen ? <CloseIcon /> : <HamburgerIcon />} aria-label="Open Menu" display={{ md: 'none' }} onClick={onToggle} />
          </Flex>
        </Flex>
      </Box>

      {/* Collapsible Mobile Menu */}
      <Collapse in={isOpen} animateOpacity>
        <Box pb={4} display={{ md: 'none' }} bg={useColorModeValue('gray.100', 'gray.900')} borderBottomWidth="1px" borderColor={useColorModeValue('gray.200', 'gray.700')}>
          <VStack as="nav" spacing={4} pt={4}>
            <RouterLink to="/" onClick={onClose}>Home</RouterLink>
            {navLinks.map((link) => (
              <SmartNavLink key={link.name} to={link.to} type={link.type} isMobile onClose={onClose}>
                {link.name}
              </SmartNavLink>
            ))}
            <Button as={RouterLink} to="/contact" colorScheme="orange" w="80%" onClick={onClose}>
              Get A Quote
            </Button>
          </VStack>
        </Box>
      </Collapse>
    </Box>
  );
}